/**
 * Constants - System-wide constants and default configurations
 */

// Server roles
const SERVER_ROLES = {
  CLIENT: 1,
  JOB_EXECUTOR: 2,
  BOTH: 3
};

// Server status
const SERVER_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
  DOWN: 3
};

// Schedule types
const SCHEDULE_TYPES = {
  ONCE: 1,
  RECURRING: 2
};

// Job status
const JOB_STATUS = {
  PENDING: 1,
  RUNNING: 2,
  COMPLETED: 3,
  FAILED: 4,
  CANCELLED: 5
};

// Execution status
const EXECUTION_STATUS = {
  RUNNING: 1,
  COMPLETED: 2,
  FAILED: 3,
  TIMEOUT: 4,
  CANCELLED: 5
};

const TASK_TYPES = {
  PATIENT_APPOINTMENT_REMINDER : {name : "Appointment Reminder", id : 1},
  PATIENT_UNCONFIRMED_APPOINTMENT_REMINDER : {name : "Unconfirmed Appointment Reminder", id : 2},
  PATIENT_APPOINTMENT_ACTIONS : {name : "Appointment Actions", id : 3},
  SYSTEM : {name : "System", id : 4},
  BULK_COMMUNICATION : {name : "Bulk Communication", id : 5}
}

const BULK_COMM_TEMPLATES = {
  FNAME:            '[NameF]',
  LNAME:            '[NameL]',
  EMAIL_DISCLAIMER: '[EmailDisclaimer]'
}

const REMINDER_TEMPLATES = {
  FNAME : '[NameF]',
  LNAME : '[NameL]',
  APPT_DATE : '[ApptDate]',
  APPT_TIME : '[ApptTime]',
  CLINIC_NAME : '[ClinicName]',
  CLINIC_LOCATION : '[ClinicLocation]',
  CONFITMATION_URL : '[ConfirmURL]',
  EMAIL_DISCLAIMER : '[EmailDisclaimer]',
  CONFITMATION_CODE : '[ConfirmCode]'
}

const PATIENT_APPOINTMENT_ACTIONS = {
  CREATED: 0,
  CHANGED: 1,
  MISSED: 2,
  CANCELLED: 3,
  DELETED: 4
}

const WORKFLOW_NODE_TYPES = {
  UNCONFIRMED: 'PATIENT_UNCONFIRMED_APPOINTMENT_REMINDER',
  REMINDER_ALL: 'PATIENT_APPOINTMENT_REMINDER',
  NOTIFICATION: 'PATIENT_APPOINTMENT_ACTIONS'
};

const WORKFLOW_NODE_ICONS = {
  [WORKFLOW_NODE_TYPES.UNCONFIRMED]: 'mdi-calendar-alert',
  [WORKFLOW_NODE_TYPES.REMINDER_ALL]: 'mdi-calendar-check',
  [WORKFLOW_NODE_TYPES.NOTIFICATION]: 'mdi-bell-ring'
};

const WORKFLOW_NODE_COLORS = {
  [WORKFLOW_NODE_TYPES.UNCONFIRMED]: 'error',
  [WORKFLOW_NODE_TYPES.REMINDER_ALL]: 'primary',
  [WORKFLOW_NODE_TYPES.NOTIFICATION]: 'success'
};

module.exports = {
  SERVER_ROLES,
  SERVER_STATUS,
  SCHEDULE_TYPES,
  JOB_STATUS,
  EXECUTION_STATUS,
  TASK_TYPES,
  REMINDER_TEMPLATES,
  BULK_COMM_TEMPLATES,
  PATIENT_APPOINTMENT_ACTIONS,
  WORKFLOW_NODE_TYPES,
  WORKFLOW_NODE_ICONS,
  WORKFLOW_NODE_COLORS
};